import { ref } from 'vue';
import { useFetch } from 'nuxt/app';
import inputs_to_key_value from 'assets/js/translators/inputs_to_key_value.translator.js';
import make_bearer_token from 'assets/js/functions/make_bearer_token.js';
import get_base_url from '~/assets/js/functions/route/get_base_url';
import make_query_params from '~/assets/js/functions/route/make_query_params';
import useAuth from '~/assets/js/composables/other/useAuth';

const useServerFetch = async (request_url, options) => {
  options = Object.assign(
    {
      placeholder: {},
      server: true,
      in_load: false,
      watch: false,
      lazy: false,
      transform: data => {
        return data.data;
      },
      onResponse: () => {},
    },
    options
  );
  const token = useAuth().getAuthToken();
  const is_loading = ref(options.in_load);
  const filters = ref({
    ...options.filters,
  });

  const fetch = async () => {
    const queries = make_query_params(inputs_to_key_value(filters.value));

    const { data, pending, refresh, execute, error, status } = await useFetch(
      request_url + queries,
      {
        timeout: 14000,
        ...options,
        headers: {
          'Accept': 'application/json',
          'Authorization': token ? make_bearer_token(token) : '',
          'X-Currency': 'IRT', // IRT | IRR
        },
        // query: inputs_to_key_value(filters.value),
        default: () => options.placeholder,
        baseURL: get_base_url(),
        // body: filters.value,
        onRequest() {
          is_loading.value = true;
        },
        onRequestError() {
          is_loading.value = false;
        },
        onResponse(rs) {
          options.onResponse(rs.response._data.data);

          is_loading.value = false;
        },
        onResponseError({ response }) {
          is_loading.value = false;
        },
      }
    );

    return {
      data,
      pending,
      refresh,
      execute,
      error,
      status,
    };
  };

  const fresh_fetch = async () => {
    const { data: inner_data } = await fetch();

    data.value = inner_data.value;
  };

  const filter = async () => {
    await fresh_fetch();
  };

  const { data, pending, refresh, execute, error, status } = await fetch();

  if (import.meta.client) {
    is_loading.value = status.value === 'pending';
  }

  if (error.value) {
    console.error(error.value);
  }

  const has_error = computed(() => Boolean(error.value));

  return {
    data,
    filters,
    is_loading,
    refresh,
    has_error,
    status,
    fetch: fresh_fetch,
    filter,
  };
};

export default useServerFetch;
